// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { node, object, string } from 'prop-types'

const h4c = 'database-details-heading bg-blue-dark padding-left-half padding-right-half uppercase display-flex justify-content-start align-items-center'

const SectionWrapper = ({ className = '', children, label, decorationL = null, decorationR = null }) => (
  <div className={`database-details-section ${className}`}>
    <h4 className={h4c}>
      {decorationL}
      {label}
      {decorationR}
    </h4>
    {children}
  </div>
)

SectionWrapper.propTypes = {
  className: string,
  children: node.isRequired,
  decorationL: object,
  decorationR: object,
  label: string.isRequired,
}

export default SectionWrapper
